module.exports = __webpack_public_path__ + "assets/assets/images/icons/arrow-right.6e8c84e4.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/arrow-right.svg
// module id = 195
// module chunks = 2